import React, { useState } from 'react';
import { PriceAdjustmentPanel } from '../components/admin/PriceAdjustmentPanel';
export const MainAdminDashboard: React.FC = () => {
  const [showPriceAdjustment, setShowPriceAdjustment] = useState(false);
  return <div className="min-h-screen bg-gray-50" data-id="element-2733">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2734">
        <div className="flex justify-between items-center mb-8" data-id="element-2735">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-2736">
            Main Admin Dashboard
          </h1>
          <button onClick={() => setShowPriceAdjustment(!showPriceAdjustment)} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold" data-id="element-2737">
            {showPriceAdjustment ? 'Hide' : 'Adjust Prices'}
          </button>
        </div>

        {/* Price Adjustment Panel */}
        {showPriceAdjustment && <div className="mb-8" data-id="element-2738">
            <PriceAdjustmentPanel data-id="element-2739" />
          </div>}

        {/* Stats Overview */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2740">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-2741">
            <h3 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-2742">
              All Regions
            </h3>
            <p className="text-3xl font-bold text-blue-600" data-id="element-2743">Total Orders</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6" data-id="element-2744">
            <h3 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-2745">
              Limpopo
            </h3>
            <p className="text-3xl font-bold text-green-600" data-id="element-2746">Orders</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6" data-id="element-2747">
            <h3 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-2748">
              Gauteng
            </h3>
            <p className="text-3xl font-bold text-purple-600" data-id="element-2749">Orders</p>
          </div>
        </div>

        {/* Regional Dashboard Links */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2750">
          <a href="/admin/limpopo" className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow" data-id="element-2751">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2752">
              Limpopo Dashboard
            </h3>
            <p className="text-gray-600" data-id="element-2753">
              View Limpopo region orders and analytics
            </p>
          </a>
          <a href="/admin/gauteng" className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow" data-id="element-2754">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2755">
              Gauteng Dashboard
            </h3>
            <p className="text-gray-600" data-id="element-2756">
              View Gauteng region orders and analytics
            </p>
          </a>
        </div>
      </div>
    </div>;
};